<template>
  <div class="personalFxPage">
    <el-row :gutter="10">
        <el-col :span="6">
            <div class="fxLeftModel">
                <div class="psersonalImg">
                    <img src="https://img1.baidu.com/it/u=3309580685,2899404314&fm=253&fmt=auto&app=138&f=JPEG?w=433&h=433" alt="">
                </div>
                <div class="psersonalModel">
                    <el-form :model="infoFrom" label-width="125px">
                        <el-form-item label="姓名：">郑学彬</el-form-item>
                        <el-form-item label="性别：">男</el-form-item>
                        <el-form-item label="民族：">汉</el-form-item>
                        <el-form-item label="年龄：">36岁</el-form-item>
                        <el-form-item label="身高：">170cm</el-form-item>
                        <el-form-item label="体重：">58kg</el-form-item>
                        <el-form-item label="工作单位：">科技部</el-form-item>
                    </el-form>

                    <!-- <div class="playModelCon">
                        <el-button size="medium" type="success" plain round>下载健康检测综合报告</el-button>
                    </div> -->
                </div>
            </div>
        </el-col>
        <el-col :span="18">
            <div class="fxRightModel">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-card class="box-card">
                            <h3>年度健康分趋势分析</h3>
                            <div id="oneTuDom" style="height: 220px;"></div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px;" :gutter="10">
                    <el-col :span="12">
                        <el-card class="box-card">
                            <h3>近期风险项分析</h3>
                            <div id="twoTuDom" style="height: 220px;"></div>
                        </el-card>
                    </el-col>
                    <el-col :span="12">
                        <el-card class="box-card">
                            <h3>最近一次健康检测情况</h3>
                            <div class="threeTuDom" style="height: 220px;">
                                <ul>
                                    <li>检测时间：2024-08-26 15:23:00</li>
                                    <li>健康分：<span style="color: red;">90</span> 分</li>
                                    <li>风险项：糖尿病风险</li>
                                    <li>异常指标：血糖偏高</li>
                                </ul>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data(){
        return {
            infoFrom:{

            },
        }
    },
    mounted(){
        this.getOneTu();
        this.getTwoTu();
        this.getThreeTu();
    },
    methods:{
        getOneTu(){
            let chartDom = document.getElementById('oneTuDom');
            let myChart = echarts.init(chartDom);
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['1月', '2月', '3月', '4月', '5月', '6月']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '健康分',
                        type: 'line',
                        stack: 'Total',
                        data: [92, 86, 90, 100, 100, 95]
                    },
                ]
            };
            option && myChart.setOption(option);
        },
        getTwoTu(){
            let chartDom = document.getElementById('twoTuDom');
            let myChart = echarts.init(chartDom);
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    top: 20,
                    right: 0,
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月', '6月'],
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '有风险',
                        type: 'bar',
                        data: [2, 3, 2, 0, 0, 1],
                        itemStyle:{ color: 'red' },
                        label: {
                            show: true,
                            formatter: '{c}项'
                        },
                    }
                ]
            };
            option && myChart.setOption(option);
        },
        getThreeTu(){
            
        },
    }
}
</script>

<style lang="less" scoped>
.personalFxPage{
    .fxLeftModel{
        min-height: 500px;
        border-right: 1px solid #f2f2f2;
        .psersonalImg{
            width: 100%;
            text-align: center;
            padding: 10px;
            box-sizing: border-box;
            img{
                width: 100px;
                height: 100px;
                border-radius: 50%;
            }
        }

        .psersonalModel{
            .playModelCon{
                margin-top: 30px;
                text-align: center;
            }
        }
    }
    .fxRightModel{
        min-height: 500px;
        width: 100%;

        .threeTuDom{
            ul{
                list-style-type: none;
                padding-left: 0px;
                li{
                    font-size: 16px;
                    line-height: 36px;
                }
            }
        }
    }
}
</style>

<style scoped>
/deep/.psersonalModel .el-form-item{
    margin-bottom: 0px;
}

.fxRightModel h3{
    margin-top: 0px;
    margin-bottom: 9px;
}

/deep/.psersonalModel .el-form-item__label{
    font-size: 14px;
    font-weight: normal !important;
}
</style>